import { Component, ViewChild, TemplateRef, ElementRef, OnInit } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AppService } from '../app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from '../support/success-snackbar/success-snackbar.component';
import { PaginationService } from '../PaginationService';
import { messageService } from '../message.service';
import { DynamicAuditTrailComponent } from '../support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from '../support/excel-pdf/excel-pdf.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { GridReorderComponent } from '../grid-reorder/grid-reorder.component';

@Component({
  selector: 'app-qmsgroups',
  templateUrl: './qmsgroups.component.html',
  styleUrls: ['./qmsgroups.component.scss']
})

export class QmsgroupsComponent implements OnInit {

  isProcessing: boolean = false;
  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService, private readonly elem: ElementRef) {
    this.message.breadcrumbData.fourthLevel = null;
  };

  auditTrail: any = {};
  visibleAuditTrail: boolean = false;

  ngOnInit(): void {
    this.dropDownForModules = JSON.parse(sessionStorage.getItem('dropDownForModules') ?? '{}');
    this.selectBoxForModule();
    this.isProcessing = true;
    this.getCall();
  };

  multipleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
  };

  onModuleSelect(item: any) {
    this.handleDropDownValidation('module', this.selectedModule)
  };

  onModuleDeSelect(item: any) {
    this.handleDropDownValidation('module', this.selectedModule)
  };

  onModuleSelectAll(item: any) {
    this.handleDropDownValidation('module', item)
  };

  onModuleDeSelectAll(item: any) {
    this.selectedModule = [];
    this.handleDropDownValidation('module', this.selectedModule)
  };

  selectBoxForModule() {
    this.moduleValueDropdown = [];
    this.moduleValueDropdown = this.dropDownForModules?.filter((item: any) => item.codelistCode != 'TRN' && item.codelistCode != 'DOCS' && item.codelistCode != 'BP').map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) || []
  }

  popupTitle: any;
  selectedModule: any = [];;
  moduleValueDropdown: any = [];
  dropDownForModules: any = [];

  openGroupDetails(event: Event, columnIndex: number, cellValue: any) {
    if (columnIndex === 0) {
      let groupCode = cellValue.GROUP_CODE.trim();
      this.message.masterDetails = this.grid.filter((x: any) => x.GROUP_CODE.trim() === groupCode);
      this.router.navigate(['dashboard/qmsgroupUsers']);
    }
    event.stopPropagation();
  }

  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  addAndEditPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  qualityGroup: any = {};
  visibleReasonForUpdateField: boolean;
  openAddPopup() {
    this.popupTitle = "Create Quality Group";
    this.selectedModule = [];
    this.visibleReasonForUpdateField = false;
    this.qualityGroup = { groupId: null, groupCode: '', groupName: '', groupDescription: '', isActive: true };
    this.selectedModule = [];
    setTimeout(() => {
      this.isAllModulesSelected = this.moduleValueDropdown.length == this.selectedModule.length;
    })
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  refreshGridData() {
    this.getCall()
  };
  focusEmpty() {
    console.log();
  }

  handleDropDownValidation(fieldId: string, selectedItems: any[]) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = selectedItems.length === 0 && field ? 'red' : '';
  }

  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = items ? '#005c8a' : 'red';
  }

  fieldValidation(elementIds: string[]) {
    elementIds.forEach((elementId) => {
      const element = document.getElementById(elementId) as HTMLInputElement;
      element.style.color = 'red';
    });
  }

  addAndEditFunction(group: any) {

    const validations = [
      { condition: !this.qualityGroup.groupCode, id: 'group-code' },
      { condition: !this.qualityGroup.groupName, id: 'group-name' },
      { condition: !this.selectedModule.length, id: 'module' }
    ]

    const invalidIds = validations.filter((validation) => validation.condition).map((validation) => validation.id);

    if (invalidIds.length > 0) {
      this.fieldValidation(invalidIds);
    } else {
      this.isProcessing = true;
      let modules = null;
      for (const module of this.selectedModule) {
        modules = modules == null ? module : modules + ',' + module;
      }
      const add_obj = {
        groupCode: group.groupCode,
        groupName: group.groupName,
        modules: modules,
        groupDescription: group.groupDescription,
        isActive: this.qualityGroup.isActive ? "Y" : "N",
      }

      this.appService.createQualityGroup(add_obj).subscribe({
        next: (Response: any) => {
          if (Response.resultType == "S") {
            this.getCall();
            this.visibleAddAndEditPopup.close();
            this.showSnackBar(Response.result, Response.resultType);
          } else {
            this.isProcessing = false;
            this.showSnackBar(Response.result, Response.resultType);
          }
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }

    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;

  deletePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  deletingGroupId: number = 0;
  deleteQualityGroup(deleting_group: any) {
    this.popupTitle = "Delete Quality Group";
    this.deletingGroupId = deleting_group.GROUP_ID;
    this.qualityGroup.deleteReason = '';
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }
  deleteFunction(deleting_group: any) {

    if (deleting_group.deleteReason) {

      this.isProcessing = true;

      const deleting_obj = {
        groupId: this.deletingGroupId,
        deleteReason: deleting_group.deleteReason,
      };

      this.appService.deleteQualityGroup(deleting_obj).subscribe({
        next: (response: any) => {

          if (response.resultType === 'S') {
            this.getCall();
            this.visibleDeletePopup.close();
          } else {
            this.isProcessing = false;
          }

          this.showSnackBar(response.result, response.resultType);

        },

        error: (error) => {
          this.isProcessing = false;
          console.error(error);
        }
      });

    } else {

      const field = document.getElementById('delete-reason') as HTMLInputElement;
      field.style.color = 'red';

    }

    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);

  }
  cancelDelete() {
    this.visibleDeletePopup.close();
  }

  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel
          ?? this.message.breadcrumbData.secondLevel
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }

  searchText: any;
  searchValue: any;
  _temp: any = {};
  columnLists: any = {};
  grid: any = [];
  gridTemp: any;
  makeStickyColumns: any;
  dataTypeList: any = [];
  visibleDataGrid: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  private readonly users: any[];
  pager: any = {};
  pagedItems: any[];
  error = '';

  getCall() {
    this.isProcessing = true;
    const data = {

      gridName: "QMS_GROUP",
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause = response.orderByClause ? response.orderByClause : "";
        this.makeStickyColumns = response.fixedFieldCnt;
        const data1: any = {

          gridName: "QMS_GROUPS_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        }
        this.reportObj = { ...data1, ...data };
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.grid = response1;
            this.visibleAuditTrail = false;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const element of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(element + 'px');
            }
            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              for (const element of this.columnLists.invisibleColumnarray) {
                if (this.columnLists.columnsListarray[y] == element) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
            }
            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const element of this.dataTypeList) {
                  if (element.columnName == this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                  }
                }
              }
              for (const rowData of this.grid) {
                for (const element of this.dataTypeList) {
                  if (element.fieldType === 'CHECKBOX') {
                    rowData[element.columnName] = rowData[element.columnName] === 'Y';
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPage(1, 0);
            });
            this.message.gridList = this.grid;
            this.collectionSize = this.grid.length;
            this.totalPages = Math.ceil(this.grid.length / this.itemsPerPage);
            this.dynamicLabelCall();
            this.isProcessing = false;
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
  }

  setPage(page: number, targetPage: number) {

    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(
      this.grid.length,
      page,
      this.perPage,
      targetPage
    );

    if (page < 1 || page > this.pager.totalPages) {
      return;
    }

    this.pagedItems = this.grid.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }

  setPagedOrSearch(page: number, targetPage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.gridTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.gridTemp.length, page, this.perPage, targetPage);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.grid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  searchValue2: any;
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.gridTemp = this.grid;
      this.pager = this.paginationService.getPager(this.gridTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      if (this.grid == undefined) {
        return this.grid;
      }
      if (!this.grid.length) {
        return this.grid;
      }
      if (filter) {
        this.gridTemp = this.grid.filter((item: any) =>
          JSON.stringify(item).toLowerCase().includes(filter)
        );
      } else {
        this.gridTemp = [...this.grid];
      }
      this.setPagedOrSearch(1, 0);
    }
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.grid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  counts: any;
  cssFunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  onClick(event: any) {

  }

  parentCheckBox: boolean = false;
  childCheckBox: boolean = false;
  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.childCheckBox = true;
      for (const element of this.grid) {
        element.childCheckBox = true;
      }
    } else {
      this.childCheckBox = false;
      for (const element of this.grid) {
        element.childCheckBox = false;
      }
    }
  }

  previousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.previousSelectedValue != undefined) {
        this.grid[this.previousSelectedValue].childCheckBox = false;
      }
      list.childCheckBox = true;
      this.auditTrail.refNo = list.RISK_ID;
    } else {
      list.childCheckBox = false;
    }
    this.previousSelectedValue = idx;
    this.visibleAuditTrail = this.grid.some((list: any) => list.childCheckBox);
  }


  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, qualityGroup: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : qualityGroup.GROUP_ID;
    this.auditTrail.gridName = 'QMS_GROUP';
    this.auditTrail.report_And_Popup_Name = 'QMS Groups Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(qualityGroup);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = this.reportObj;
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = 'QMS Groups Report';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  modulesSearchText: any = "";
  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }
  onModulesSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.handleDropDownValidation('module', this.selectedModule);
        this.isAllModulesSelected = this.moduleValueDropdown.length == this.selectedModule.length;
      })
    }
  }

  @ViewChild('modules') modules: MatSelect;
  isAllModulesSelected = false;

  toggleAllSelection(value: any) {
    if (value == 'modules') {
      if (this.isAllModulesSelected) this.modules.options.forEach((item: MatOption) => item.select());
      else this.modules.options.forEach((item: MatOption) => item.deselect());
    }
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, null, 0)
  }

  onChildValueEmitted() {
    this.getCall();
  };

  dynamicLabel: any = null;
  label: any = [];
  dynamicLabelCall() {

    this.isProcessing = true;

    const data = {
      tableName: this.reportObj.tableOrViewName,
      moduleName: null,
      gridName: this.reportObj.gridName,
      groupId: 0
    };

    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (response: any) => {
        this.label = response;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[user.columnName] = user.changedFieldName;
          return acc;
        }, {});
        this.isProcessing = false;
      },
      error: (error: any) => {
        this.isProcessing = false;
        console.error(error);
      }
    });
  }
}
